// Use ?? (not ||) so an explicit empty string is respected. Building with
// REACT_APP_API_ROOT="" makes all calls same-origin/relative (e.g. "/api/"),
// which is what the Dockerized stack uses so ONE build works on localhost and
// on staging without rebuilding. `npm start` (no var set) still hits :8000.
const API_ROOT = process.env.REACT_APP_API_ROOT ?? 'http://localhost:8000';
export const BASE_URL = API_ROOT + "/api/";
export const GET_USER_EXISTS_URL = `${BASE_URL}user/`;

export const SEND_AUTH_CODE_URL = `${BASE_URL}drf-passwordless-login/auth/email/`;
export const VERIFY_AUTH_CODE_URL = `${BASE_URL}drf-passwordless-login/auth/token/`;

export const GET_COMPANIES_URL = `${BASE_URL}company/`;
export const COMPANY_FORM_OPTIONS_URL = `${BASE_URL}company/form-options/`;
export const GET_USER_REMINDERS_URL = `${BASE_URL}get_user_reminders/`;
export const GET_TASK_URL = `${BASE_URL}task/`
export const CHECK_LOGIN_URL = `${BASE_URL}checklogin/`;
export const REGISTER_URL = `${BASE_URL}registration/`;
export const GET_TAXATION_URL = `${BASE_URL}taxation/`;
export const GET_TAXSTATUSCHOICES_URL = `${BASE_URL}taxstatus_transition/`;
export const GET_FINANCIAL_STATEMENT_URL = `${BASE_URL}financial_statement/`;

export const GET_CURRENT_USER_URL = `${BASE_URL}current/user`;
export const LOGOUT_URL = `${BASE_URL}auth/logout/`;
export const LOGIN_STATS_URL = `${BASE_URL}login-stats/`;
export const COMPANY_PRESENCE_URL = `${BASE_URL}company-presence/`;
export const COMPANY_CHAT_URL = `${BASE_URL}company_chat/`;
export const COMPANY_CHAT_INBOX_URL = `${BASE_URL}company_chat/inbox/`;
export const COMPANY_CHAT_ALERTS_URL = `${BASE_URL}company_chat/alerts/`;
export const COMPANY_CHAT_MARK_READ_URL = `${BASE_URL}company_chat/mark_read/`;
export const GET_NOTIFICATIONS_URL = `${BASE_URL}notifications/`;

export const FILES_URL = `${BASE_URL}customerfiles/`;
export const NON_SLCS_FILES_URL = `${BASE_URL}non_slcs_files/`;
export const ORG_ASSOCIATIONS_URL = `${BASE_URL}org_associations/`;
export const ORG_HIERARCHY_URL = `${BASE_URL}org_associations/hierarchy/`;
export const ORG_HIERARCHY_CHILDREN_URL = `${BASE_URL}org_associations/children/`;
export const ORG_DOCUMENTS_URL = `${BASE_URL}org_documents/`;
export const GET_ADMIN_URL = `${API_ROOT}/admin`;

/** Django group name that unlocks Organization Hierarchy UI (full edit). */
export const ORG_HIERARCHY_GROUP = "Org Hierarchy";
/** Read-only org chart + files; client modal shows details tab only. */
export const HAI_READ_ONLY_GROUP = "HAI Read Only";

export const TASK_FILE_URL = `${BASE_URL}task_files/`;
export const UPDATE_USER_URL = `${BASE_URL}deactivate/`;
export const ONE_DRIVE_FILES_URL = `${BASE_URL}get_one_drive_data/get_data/`;
export const COMPANY_REPORT_CSV_URL = `${BASE_URL}reports/company-csv/`;
export const FINANCIAL_STATEMENTS_REPORT_HTML_URL = `${BASE_URL}reports/financial-statements-html/`;
export const FINANCIAL_STATEMENTS_EARLY_STAGE_CSV_URL = `${BASE_URL}reports/financial-statements-early-stage-csv/`;
export const FINANCIAL_STATEMENTS_YEARLY_SUMMARY_HTML_URL = `${BASE_URL}reports/financial-statements-yearly-summary-html/`;
export const START_FINANCIAL_STATEMENTS_PROCESS_URL = `${BASE_URL}process/start-financial-statements/`;

export const TAXATION_REMINDERS_LIST_URL = `${BASE_URL}taxation-reminders/`;
export const TAXATION_REMINDER_PREVIEW_URL = (taxationId) =>
  `${BASE_URL}taxation-reminders/${taxationId}/preview/`;
export const TAXATION_REMINDER_SEND_URL = `${BASE_URL}taxation-reminders/send/`;

export const GET_POTENTIAL_CLIENTS_URL = `${BASE_URL}potential_client/`;

export const SEND_TASK_OPENED_EMAIL_URL = `${BASE_URL}send_task_opened_email/`;
